import React from 'react'

import { TFilterDefaults } from '@mindfulchefuk/components/Search/Filters/types'
import { capitalizeSlug } from '@mindfulchefuk/utils/capitalizeSlug'
import MainLayout from '@mindfulchefuk/layouts/MainLayout'
import RecipesSearchLayout from '@mindfulchefuk/layouts/RecipesSearchLayout'

export type TSearchPage = {
  slug: string
  filter: TFilterDefaults
}

export const SearchPage = ({ slug, filter }: TSearchPage) => {
  const title = capitalizeSlug(slug)

  return (
    <MainLayout
      title={`${title} | Healthy Food & Recipe Box Delivery | Mindful Chef`}
      description={`${title}. Meals made easy with the UK's highest-rated recipe box. We deliver fresh ingredients for new healthy and delicious recipes every week.`}
      canonical={slug}
    >
      <RecipesSearchLayout
        filterDefaults={filter}
        mainSection={
          <>
            <h1>{title}</h1>
            <p>
              Welcome to our healthy recipe library. Here you’ll find our full
              range of over 800 delicious recipes, completely free for you to
              browse, cook and enjoy. If you are looking for healthy recipe
              inspiration, you&apos;ve come to the right place.
            </p>
          </>
        }
        secondarySection={
          <>
            <h2>About our meals</h2>
            <p>
              All of our healthy meals are 100% gluten-free. With no stodgy
              carbs you can be assured all of our recipes are the perfect
              accompaniment to a healthy lifestyle. We use only the best
              ingredients. To ensure this we work closely with small family-run
              British farms to have complete transparency over quality and
              sustainability.
              <br />
              <br />
              Whether you live alone, are in a couple or have a family, our
              healthy recipes can help make meals times that little bit easier.
              Use the filter to see the variety of recipes on offer allowing you
              to whip up a tasty home cooked meal every day without ever having
              to worry.
              <br />
              <br />
              We&apos;ve done all the hard work so you don&apos;t have to! Let
              us help fuel your health goals, with nutritious, delicious meals.
            </p>
          </>
        }
      />
    </MainLayout>
  )
}
